<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Manage Sales
      </h6>

      <div class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0" class="navbar background_color">
          <div class="d-flex flex-column flex-md-row flex-wrap gap-2">
            <b-input-group size="sm" class="w-100" style="max-width: 225px;">
              <b-form-input
                id="filter-input"
                v-model="filter"
                @input="loadSales()"
                type="search"
                placeholder="Search"
                class="bdr-rad"
              />
            </b-input-group>

            <b-input-group class="w-100" style="max-width: 225px;">
              <DatePicker
                v-model="FromDate"
                @input="loadSales()"
                placeholder="From Date"
                class="bdr-rad"
                style="width: 100%;"
              />
            </b-input-group>

            <b-input-group size="sm" class="w-100" style="max-width: 225px;">
              <DatePicker
                v-model="ToDate"
                @input="loadSales()"
                placeholder="To Date"
                class="bdr-rad"
                style="width: 100%;"
              />
            </b-input-group>

            <div class="ms-md-2 mt-2 mt-md-0">
              <span class="custom-breadcrumb">
                <b>Showing {{ currentPage }} - {{ currentPage * perPage }} of {{ totalRows }} items.</b>
              </span>
            </div>
          </div>

          <div class="d-grid gap-2 d-md-flex justify-content-md-end">
            <button @click="createSales()" class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad">
              Create Sales
            </button>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body mb-5">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else>
              <div class="table-responsive">
                <b-table
                  responsive
                  style="font-size: small;"
                  class="table-hover"
                  :items="sales"
                  :fields="fields"
                  :current-page="currentPage"
                  head-variant="dark"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  show-empty
                  small
                >
                  <template #cell(actions)="row">
                    <div class="dropdown">
                      <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                        Action
                      </button>
                      <div class="dropdown-menu bdr-rad">
                        <a class="dropdown-item mouse-cursor" @click="viewItem(row.item.id)">View</a>
                        <a class="dropdown-item mouse-cursor" v-if="row.item.status_value == 1" @click="confirmItem(row.item.id)">Confirm</a>
                        <a class="dropdown-item mouse-cursor" v-if="row.item.status_value == 3" @click="createGin(row.item.id)">Create GIN</a>
                      </div>
                    </div>
                  </template>

                  <template #cell(number)="row">
                    {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1) * 10 + row.index + 1 }}
                  </template>
                </b-table>

                <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
                  <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm" />
                </b-col>
              </div>
            </div>
          </div>
        </div>
        <br><br><br>
      </div>
    </div>

    <b-modal :id="confirmModal.id" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" bottom>
      <template #modal-title>
        <h3>Confirm !</h3>
      </template>
      <div class="d-block text-center">
        <h5>Are you sure you want to Confirm ?</h5>
      </div>
      <hr>
      <template #modal-footer>
        <button style="font-size: small;" @click="confirmSales(confirmModal.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
        <button style="font-size: small;" @click="$bvModal.hide(confirmModal.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
      </template>
    </b-modal>

    <content-footer></content-footer>
  </div>
</template>

<script>
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DatePicker,
  },
  mounted() {
    this.loadSales();
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      FromDate: null,
      ToDate: null,
      filterOn: [],
      sales: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      isLoading: true,
      confirmModal: {
        id: 'confirm-sales-modal',
        content: null,
      },
      headerBgVariant: 'mycoolor',
      headerTextVariant: 'light',
      fields: [
        { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
        { key: 'so_num', label: 'Sales No.', sortable: true },
        { key: 'customer_name', label: 'Customer', sortable: true },
        { key: 'sales_date', label: 'Sales Date', sortable: true },
        { key: 'total', label: 'Total', sortable: true },
        { key: 'payment_method', label: 'Payment Method', sortable: true },
        { key: 'status_name', label: 'Status', sortable: true },
        { key: 'created_date', label: 'Created Date', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  methods: {
    createSales() {
      this.$router.push('/dsales/create');
    },
    viewItem(id) {
      this.$router.push('/dsales/view?id=' + id);
    },
    createSo(id) {
      this.$router.push('/ssalesorder/create?id=' + id);
    },
    createGin(id) {
      this.$router.push('/dgin/create?id=' + id);
    },
    confirmItem(id) {
      this.confirmModal.content = id;
      this.$root.$emit('bv::show::modal', this.confirmModal.id);
    },
    async confirmSales(id) {
      try {
        const { data } = await axios.get('/dsales/confirm?id=' + id, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });
        if (data && data.status === 200) {
          this.$bvModal.hide(this.confirmModal.id);
          this.loadSales();
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
    async loadSales(page = this.currentPage) {
      try {
        const { data } = await axios.get('/dsales/index', {
          params: {
            page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });
        this.sales = data.all_data || [];
        this.totalRows = data.total_count || 0;
        this.currentPage = data.page || 1;
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.mouse-cursor {
  cursor: pointer;
}
</style>
